import React from 'react';
import { Table, Status, Icon, ToastContext, InfoText } from '@weezevent/nacre';
import { fetcher } from '@weezevent/weezjs-core';
import { useTranslation } from 'react-i18next';
import useDateFormat from '../../../../../components/utils/useDateFormat';

const CheckoutLine = ({ ticket_office, displayData, organization, syncData, loadingData }) => {
    const { t } = useTranslation();
    const toast = React.useContext(ToastContext);
    const closeMySession = React.useCallback(
        cash_balance => {
            fetcher
                .get(`/ticket/organizations/${organization.id}/ticket_office/${ticket_office.id}/session/${cash_balance.session_id}/close_session`)
                .then(response => {
                    toast.success(t('ticket.sales_report.close_session.success'));
                    syncData();
                })
                .catch(error => toast.error(t('ticket.sales_report.close_session.error')));
        },
        [organization, ticket_office]
    );

    const downloadMyReport = React.useCallback(
        cash_balance => {
            const token = fetcher.authorizationHeader;
            const host = fetcher.endpoint;
            const myHeaders = new Headers();
            myHeaders.append('Authorization', token);
            const requestOptions = {
                method: 'GET',
                headers: myHeaders
            };
            fetch(`${host}/ticket/organizations/${organization.id}/ticket_office/${ticket_office.id}/session/${cash_balance.session_id}/download_cash_balance`, requestOptions)
                .then(response => response.blob())
                .then(blob => {
                    const file = window.URL.createObjectURL(blob);
                    window.open(file, '_blank');
                })
                .catch(error => toast.error(t('ticket.sales_report.report.error')));
        },
        [fetcher]
    );

    const getOperatorName = React.useCallback(
        cashBalance => {
            if (cashBalance.partner_id === 0) {
                return organization.name;
            } else if (!cashBalance.name) {
                return t('ticket.sales_report.deleted_operator');
            }
            return cashBalance.name;
        },
        [organization]
    );

    return (
        <Table.TBody>
            {displayData &&
                displayData.map((cashBalance, index) => {
                    return (
                        <Table.Tr key={index}>
                            <Table.Td>{cashBalance.session_id || '-'}</Table.Td>
                            <Table.Td>{getOperatorName(cashBalance)}</Table.Td>
                            <Table.Td>
                                <InfoText subtitle={useDateFormat({ organization, date: cashBalance.start_date, timeStyle: 'short' })[1]}>
                                    {useDateFormat({ organization, date: cashBalance.start_date, timeStyle: 'short' })[2]}
                                </InfoText>
                            </Table.Td>
                            <Table.Td>
                                {cashBalance.end_date ? (
                                    <InfoText subtitle={useDateFormat({ organization, date: cashBalance.end_date, timeStyle: 'short' })[1]}>
                                        {useDateFormat({ organization, date: cashBalance.end_date, timeStyle: 'short' })[2]}
                                    </InfoText>
                                ) : (
                                    'En cours'
                                )}
                            </Table.Td>
                            {cashBalance.end_date ? (
                                <Table.Td>
                                    <Status text={t('ticket.sales_report.filter.finish')} color="black" displayBorder />
                                </Table.Td>
                            ) : (
                                <Table.Td>
                                    <Status text={t('ticket.sales_report.filter.inProgress')} color="orange" displayBorder />
                                </Table.Td>
                            )}
                            {cashBalance.end_date ? (
                                <Table.Td>
                                    <Icon name="download" onClick={() => downloadMyReport(cashBalance)} />
                                </Table.Td>
                            ) : (
                                <Table.Td>
                                    <Icon name="cross-circle" onClick={() => closeMySession(cashBalance)} />{' '}
                                </Table.Td>
                            )}
                        </Table.Tr>
                    );
                })}
        </Table.TBody>
    );
};

export default CheckoutLine;
